import React from 'react';
import { useLocale } from 'next-intl';

import Form from '../../molecules/form/form';
import bookingGerman from './data/01-booking';
import bookingEnglish from './data/02-booking-en';

const bookingData = {
  de: bookingGerman,
  en: bookingEnglish
};

const BookingForm = () => {
  const locale = useLocale();
  return <Form {...bookingData[locale]} withCsrfToken />;
};

export default BookingForm;
